module.exports = __webpack_public_path__ + "static/img/buttons-sizing-small-in-button.a6aafa1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons-sizing-small-in-button.svg
// module id = MH6J
// module chunks = 0